export default "__VITE_ASSET__DPBveRB___"